import React from "react";
import { useSelector } from "react-redux";
import { downloadFiles } from "features/recipe/recipeSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "app/store";

const AssetsPopup = ({ setOpenModal, assets }: any) => {
  const dispatch = useDispatch<AppDispatch>();

  return (
    <>
      <div className="fixed inset-0 z-10 overflow-y-auto h-[90%] top-[5%]">
        <div
          className="fixed inset-0 w-full h-full bg-black opacity-40"
          onClick={() => setOpenModal(false)}
        ></div>
        <div className="flex items-center min-h-screen">
          <div className="flex flex-col justify-center relative w-full max-w-7xl p-8 mx-auto bg-white rounded-lg shadow-[2px_4px_9px_rgba(0,0,0,0.2)]">
            <div className="flex flex-row min-w-full">
              <p className="basis-1/4 text-[0.85rem] text-primary font-medium">Field</p>
              <p className="basis-3/4 text-[0.85rem] text-primary font-medium">Assets</p>
            </div>
            <div className="my-5 h-0.5 w-full bg-slate-300 opacity-50" />
            {assets?.map((asset, i) => {
              return (
                <div key={i}>
                <div className="flex flex-row justify-center items-center mt-2">
                  <div className="flex items-center basis-1/4 my-5 ">
                    <p className="text-[0.85rem] text-primary font-medium mb-5">{asset.key}</p>
                  </div>
                  <div className="flex flex-col justify-center basis-3/4 overflow-hidden">
                    {asset.items.map((file, i) => {
                      return (
                        <div key={i}>
                          <p 
                            className="text-[0.85rem] break-words text-primary mb-5 hover:underline hover:cursor-pointer"
                            onClick={() => {
                                dispatch(downloadFiles(file.name)).then(async (res) => {
                                  window.location.href = res.payload.downloadUrl;
                                })
                              }}
                          >
                            {file.name.split("/").pop()}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                  
                </div>
                <div className="my-5 h-0.5 w-full bg-slate-300 opacity-50" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default AssetsPopup;
